import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';
import './lib/theme'; // side-effect: paints the persisted light/dark mode before render

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// Open the native picker when the WHOLE date/time field is clicked (not just the
// calendar icon). showPicker() needs a user gesture; guarded for browser support.
document.addEventListener('click', (e) => {
  const el = e.target;
  if (
    el instanceof HTMLInputElement &&
    ['date', 'datetime-local', 'time', 'month', 'week'].includes(el.type) &&
    typeof el.showPicker === 'function'
  ) {
    try {
      el.showPicker();
    } catch {
      /* NotAllowedError / unsupported — the native icon still opens it */
    }
  }
});
